import { createFileRoute } from '@tanstack/react-router'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Badge } from '@/components/ui/badge'
import { UserPlus, Mail, Crown, User } from 'lucide-react'

export const Route = createFileRoute('/dashboard/settings/team')({ 
  component: TeamManagement
})

function TeamManagement() {
  return (
    <ProtectedRoute>
      <div className="space-y-8">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Team Management</h1>
          <p className="text-gray-600">Manage team members and their access permissions</p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Invite Team Members</CardTitle>
            <CardDescription>
              Add new team members to collaborate on your API projects
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="flex gap-2">
              <Input placeholder="Enter email address" className="flex-1" />
              <Button>
                <UserPlus className="w-4 h-4 mr-2" />
                Invite
              </Button>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Team Members</CardTitle>
            <CardDescription>
              Current team members and their roles
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="flex items-center justify-between p-4 border rounded-lg">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                    <Crown className="w-5 h-5 text-blue-600" />
                  </div>
                  <div>
                    <p className="font-medium">You</p>
                    <p className="text-sm text-gray-600">owner@example.com</p>
                  </div>
                </div>
                <Badge variant="default">Owner</Badge>
              </div>
              
              <div className="text-center py-8 text-gray-500">
                No team members yet. Invite your first team member to get started.
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </ProtectedRoute>
  )
}